import styles from './HulamHome.module.scss';
import { DeleteIcon } from 'components/icon';
import { useLocation } from 'react-router-dom';
import { callApi, handlerEventLog, snackBar, alert } from 'utils';
import { useAuth } from 'AuthProvider';
import { Button, Flex, MultiButton, IconButton } from 'components/hulam_platform';
import logo from 'assets/images/logo.svg';
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { Skeleton } from 'antd';
import Cookies from 'js-cookie';
import { ErrorNotiItem } from '../../components/error-noti-item';
import { MinimumWageBanner } from '../../components/banner/minimum-wage-banner';
import { onBoardingInfo } from '../../utils/mockData';
import { checkIsInt, recordOnboardingCheck } from '../../utils/onboardingUtils';
import { OnboardingItem } from '../../components/onboarding/onboarding-item';
import { OnBoardingVideoModal } from '../../components/onboarding/onboarding-video-modal';

dayjs.extend(isBetween);

export const HulamHome = () => {
  const [noticeList, setNoticeList] = useState([]);
  const { author, onBoardingClose, onBoardingHandler, companyData } = useAuth();
  const isMinWageBanner = dayjs().isBefore('2025-02-28');
  const [isOnBoardingInit, setIsOnBoardingInit] = useState(null);
  const [onboardingModal, setOnboardingModal] = useState(false);
  const [onBoardingData, setOnBoardingData] = useState({
    title: '',
    description: '',
    videoId: '',
  });

  const getNoticeList = async () => {
    let opId = sessionStorage.getItem('userId');

    const postData = {
      opId: opId,
    };

    const { data } = await callApi('api/platform/getNoticeList', postData);

    if (data.length > 5) {
      return setNoticeList(data.slice(0, 5));
    } else {
      return setNoticeList(data);
    }
  };

  const location = useLocation();

  useEffect(() => {
    async function welcomeSnack() {
      const locationState = location.state;
      let opId = sessionStorage.getItem('userId');

      if (locationState === 'initLogin' && companyData.companyName) {
        snackBar(`${companyData.companyName}로 로그인되었습니다.`);
        const eventLog = {
          href: window.location.href,
          event_type: 'login',
          userId: opId,
          category: 'member_status',
          message: '',
          source: '',
          label1: '',
          label2: '',
          slack_message: `[로그인]\n업무 대행사:${companyData.companyName} (${opId})`,
          slack_type: 'hulampro',
        };

        await handlerEventLog(eventLog);
        // state값 초기화
        window.history.replaceState({}, document.title);
      }
    }

    welcomeSnack();
  }, [location.state, companyData.companyName]);

  useEffect(() => {
    const isClose = Cookies.get('onBoarding');

    if (!isClose) {
      const count = localStorage.getItem('lookOnboardingCount') || 0;

      if (count && count > 1) {
        if (!Cookies.get('onBoarding')) {
          Cookies.set('onBoarding', 'close');
        }
      } else {
        localStorage.setItem('lookOnboardingCount', count ? Number(count) + 1 : '1');
      }
    }

    const exposureCount = localStorage.getItem('exposureCount') || 0;

    if (dayjs().format('YYYY-MM-DD') < '2024-11-29' && exposureCount < 2) {
      alert({
        icon: true,
        title: '휴램프로 이용요금 공개',
        content: `
          무료체험 기간이 끝난 (10월 1일 전 가입) \n
          노무법인 계정에 11월 말일 금액이 청구될 예정이에요.\n
          자세한 사항은 공지사항을 참고해주세요.
        `,
        type: 'confirm',
        okText: '상세보기',
        cancelText: '닫기',
        onOk: () =>
          window.open(
            'https://shimmer-vein-8d5.notion.site/1295807a34bf8062bcf6ca7ec9efade2?pvs=4'
          ),
      });

      localStorage.setItem('exposureCount', (Number(exposureCount) + 1).toString());
    }

    const currentPageData = onBoardingInfo[location.pathname];

    if (currentPageData) {
      setOnBoardingData(currentPageData);
    }

    const isInitOnboarding = checkIsInt(location.pathname);

    setIsOnBoardingInit(isInitOnboarding);
  }, []);

  useEffect(() => {
    if (onBoardingClose && sessionStorage.getItem('userId')) {
      getNoticeList();
    }
  }, [onBoardingClose]);

  const onOpenVideoModal = () => {
    setOnboardingModal(true);
  };

  const onCloseVideoModal = () => {
    setOnboardingModal(false);
  };

  const setPageOnboarding = () => {
    recordOnboardingCheck(location.pathname);

    setIsOnBoardingInit(false);
  };

  return (
    <div>
      {(onBoardingClose || author === 'employee') && (
        <>
          <ErrorNotiItem id={sessionStorage.getItem('userId')} />
          <div className={styles.notice_wrap}>
            <div className={styles.notice_top}>
              <h2>공지사항</h2>
              <Button
                type="line-gray"
                size="sm"
                href="https://shimmer-vein-8d5.notion.site/daedc2f44cd3467ab9ee774f9ad7239e"
                target="_blank"
              >
                전체보기
              </Button>
            </div>
            <ul>
              <li className={styles.notice_table_row}>
                <strong>제목</strong>
                <strong>작성일</strong>
              </li>
              {noticeList.length > 0 ? (
                noticeList.map(item => {
                  return (
                    <li
                      onClick={() => window.open(item.url)}
                      className={styles.notice_table_row}
                      key={item.url}
                    >
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7 }}>
                        {item.tag === 'new' && (
                          <svg
                            width="30"
                            height="17"
                            viewBox="0 0 30 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect x="0.5" y="1" width="29" height="15" rx="2.5" stroke="#EA4549" />
                            <path
                              d="M6.06216 11.5V4.84H7.41216L9.34716 8.395L10.0222 9.835H10.0672C9.99516 9.142 9.88716 8.251 9.88716 7.495V4.84H11.1562V11.5H9.79716L7.87116 7.936L7.19616 6.514H7.15116C7.21416 7.225 7.32216 8.062 7.32216 8.836V11.5H6.06216ZM12.8034 11.5V4.84H16.8894V5.947H14.1354V7.486H16.4664V8.611H14.1354V10.384H16.9884V11.5H12.8034ZM18.9705 11.5L17.6835 4.84H19.0425L19.5645 8.089C19.6725 8.791 19.7715 9.502 19.8795 10.222H19.9155C20.0505 9.502 20.1945 8.791 20.3385 8.089L21.1035 4.84H22.2465L23.0205 8.089C23.1645 8.782 23.2905 9.502 23.4435 10.222H23.4885C23.5785 9.502 23.6865 8.791 23.7765 8.089L24.3165 4.84H25.5765L24.3435 11.5H22.6785L21.9405 8.206C21.8235 7.693 21.7335 7.171 21.6525 6.667H21.6165C21.5265 7.171 21.4275 7.693 21.3285 8.206L20.5995 11.5H18.9705Z"
                              fill="#EA4549"
                            />
                          </svg>
                        )}
                        {item.title}
                      </span>
                      <span className={styles.notice_table_date}>
                        {dayjs(item.date).format('YYYY.MM.DD HH:mm')}
                      </span>
                    </li>
                  );
                })
              ) : (
                <>
                  <li className={styles.notice_table_row}>
                    <span>
                      <Skeleton.Input active block />
                    </span>
                    <span>
                      <Skeleton.Input active block />
                    </span>
                  </li>
                  <li className={styles.notice_table_row}>
                    <span>
                      <Skeleton.Input active block />
                    </span>
                    <span>
                      <Skeleton.Input active block />
                    </span>
                  </li>
                  <li className={styles.notice_table_row}>
                    <span>
                      <Skeleton.Input active block />
                    </span>
                    <span>
                      <Skeleton.Input active block />
                    </span>
                  </li>
                  <li className={styles.notice_table_row}>
                    <span>
                      <Skeleton.Input active block />
                    </span>
                    <span>
                      <Skeleton.Input active block />
                    </span>
                  </li>
                  <li className={styles.notice_table_row}>
                    <span>
                      <Skeleton.Input active block />
                    </span>
                    <span>
                      <Skeleton.Input active block />
                    </span>
                  </li>
                </>
              )}
            </ul>
          </div>
          {isMinWageBanner && <MinimumWageBanner style={{ marginBottom: 30, cursor: 'pointer' }} />}
          {author !== 'employee' && (
            <MultiButton columnGap={20}>
              <IconButton
                style={{
                  flexDirection: 'column',
                  width: 138,
                  height: 120,
                  background: '#F4F7FA',
                  color: 'var(--gray-900-heading)',
                }}
                href="/hulamEmployee"
              >
                <svg
                  width="46"
                  height="46"
                  viewBox="0 0 46 46"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M23 8.40385C19.3707 8.40385 16.4286 11.3743 16.4286 15.0385C16.4286 18.7027 19.3707 21.6731 23 21.6731C26.6293 21.6731 29.5714 18.7027 29.5714 15.0385C29.5714 11.3743 26.6293 8.40385 23 8.40385ZM13.8 15.0385C13.8 9.90859 17.919 5.75 23 5.75C28.081 5.75 32.1999 9.90859 32.1999 15.0385C32.1999 20.1683 28.081 24.3269 23 24.3269C17.919 24.3269 13.8 20.1683 13.8 15.0385ZM18.3684 27.8653C18.4509 27.8654 18.5344 27.8654 18.6191 27.8654H27.3809C27.4656 27.8654 27.5491 27.8654 27.6315 27.8653C29.8362 27.8648 31.2414 27.8645 32.4258 28.2272C35.086 29.042 37.1678 31.1438 37.9748 33.8297C38.3341 35.0254 38.3338 36.4442 38.3333 38.6701C38.3333 38.7533 38.3333 38.8376 38.3333 38.9231C38.3333 39.6559 37.7448 40.25 37.019 40.25C36.2931 40.25 35.7047 39.6559 35.7047 38.9231C35.7047 36.3575 35.6904 35.3688 35.4595 34.6001C34.9073 32.7624 33.4829 31.3243 31.6627 30.7668C30.9013 30.5336 29.9221 30.5192 27.3809 30.5192H18.6191C16.0779 30.5192 15.0987 30.5336 14.3373 30.7668C12.5171 31.3243 11.0927 32.7624 10.5405 34.6001C10.3096 35.3688 10.2953 36.3575 10.2953 38.9231C10.2953 39.6559 9.70686 40.25 8.98101 40.25C8.25515 40.25 7.66673 39.6559 7.66673 38.9231C7.66673 38.8376 7.66671 38.7533 7.66669 38.6701C7.6662 36.4442 7.66589 35.0254 8.02515 33.8297C8.83214 31.1438 10.9139 29.042 13.5742 28.2272C14.7585 27.8645 16.1638 27.8648 18.3684 27.8653Z"
                    fill="#37383D"
                  />
                </svg>
                직원 관리
              </IconButton>
              <IconButton
                style={{
                  flexDirection: 'column',
                  width: 138,
                  height: 120,
                  background: '#F4F7FA',
                  color: 'var(--gray-900-heading)',
                }}
                href="/hulamCompanyList"
              >
                <svg
                  width="46"
                  height="46"
                  viewBox="0 0 46 46"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.2917 10.5413C15.7833 10.5413 15.2958 10.7433 14.9364 11.1027C14.5769 11.4622 14.375 11.9497 14.375 12.458C14.375 12.9663 14.5769 13.4539 14.9364 13.8133C15.2958 14.1727 15.7833 14.3747 16.2917 14.3747C16.8 14.3747 17.2875 14.1727 17.6469 13.8133C18.0064 13.4539 18.2083 12.9663 18.2083 12.458C18.2083 11.9497 18.0064 11.4622 17.6469 11.1027C17.2875 10.7433 16.8 10.5413 16.2917 10.5413ZM14.375 25.8747C14.375 25.3663 14.5769 24.8788 14.9364 24.5194C15.2958 24.1599 15.7833 23.958 16.2917 23.958C16.8 23.958 17.2875 24.1599 17.6469 24.5194C18.0064 24.8788 18.2083 25.3663 18.2083 25.8747C18.2083 26.383 18.0064 26.8705 17.6469 27.23C17.2875 27.5894 16.8 27.7913 16.2917 27.7913C15.7833 27.7913 15.2958 27.5894 14.9364 27.23C14.5769 26.8705 14.375 26.383 14.375 25.8747ZM16.2917 17.2497C15.7833 17.2497 15.2958 17.4516 14.9364 17.8111C14.5769 18.1705 14.375 18.658 14.375 19.1663C14.375 19.6747 14.5769 20.1622 14.9364 20.5216C15.2958 20.8811 15.7833 21.083 16.2917 21.083C16.8 21.083 17.2875 20.8811 17.6469 20.5216C18.0064 20.1622 18.2083 19.6747 18.2083 19.1663C18.2083 18.658 18.0064 18.1705 17.6469 17.8111C17.2875 17.4516 16.8 17.2497 16.2917 17.2497ZM21.0833 12.458C21.0833 11.9497 21.2853 11.4622 21.6447 11.1027C22.0041 10.7433 22.4917 10.5413 23 10.5413C23.5083 10.5413 23.9958 10.7433 24.3553 11.1027C24.7147 11.4622 24.9167 11.9497 24.9167 12.458C24.9167 12.9663 24.7147 13.4539 24.3553 13.8133C23.9958 14.1727 23.5083 14.3747 23 14.3747C22.4917 14.3747 22.0041 14.1727 21.6447 13.8133C21.2853 13.4539 21.0833 12.9663 21.0833 12.458ZM23 23.958C22.4917 23.958 22.0041 24.1599 21.6447 24.5194C21.2853 24.8788 21.0833 25.3663 21.0833 25.8747C21.0833 26.383 21.2853 26.8705 21.6447 27.23C22.0041 27.5894 22.4917 27.7913 23 27.7913C23.5083 27.7913 23.9958 27.5894 24.3553 27.23C24.7147 26.8705 24.9167 26.383 24.9167 25.8747C24.9167 25.3663 24.7147 24.8788 24.3553 24.5194C23.9958 24.1599 23.5083 23.958 23 23.958ZM27.7917 25.8747C27.7917 25.3663 27.9936 24.8788 28.353 24.5194C28.7125 24.1599 29.2 23.958 29.7083 23.958C30.2167 23.958 30.7042 24.1599 31.0636 24.5194C31.4231 24.8788 31.625 25.3663 31.625 25.8747C31.625 26.383 31.4231 26.8705 31.0636 27.23C30.7042 27.5894 30.2167 27.7913 29.7083 27.7913C29.2 27.7913 28.7125 27.5894 28.353 27.23C27.9936 26.8705 27.7917 26.383 27.7917 25.8747ZM23 17.2497C22.4917 17.2497 22.0041 17.4516 21.6447 17.8111C21.2853 18.1705 21.0833 18.658 21.0833 19.1663C21.0833 19.6747 21.2853 20.1622 21.6447 20.5216C22.0041 20.8811 22.4917 21.083 23 21.083C23.5083 21.083 23.9958 20.8811 24.3553 20.5216C24.7147 20.1622 24.9167 19.6747 24.9167 19.1663C24.9167 18.658 24.7147 18.1705 24.3553 17.8111C23.9958 17.4516 23.5083 17.2497 23 17.2497ZM11.9792 3.83301C10.8354 3.83301 9.73851 4.28736 8.92976 5.09611C8.12101 5.90486 7.66666 7.00176 7.66666 8.14551V39.7705C7.66666 40.564 8.31066 41.208 9.10416 41.208H36.9016C37.2828 41.208 37.6485 41.0566 37.918 40.787C38.1876 40.5174 38.3391 40.1518 38.3391 39.7705V22.5205C38.3391 21.9542 38.2275 21.3934 38.0108 20.8702C37.7941 20.347 37.4764 19.8716 37.076 19.4711C36.6755 19.0707 36.2001 18.753 35.6769 18.5363C35.1537 18.3196 34.5929 18.208 34.0266 18.208H31.625V8.14551C31.625 7.00176 31.1706 5.90486 30.3619 5.09611C29.5531 4.28736 28.4562 3.83301 27.3125 3.83301H11.9792ZM10.5417 8.14551C10.5417 7.76426 10.6931 7.39863 10.9627 7.12904C11.2323 6.85946 11.5979 6.70801 11.9792 6.70801H27.3125C27.6937 6.70801 28.0594 6.85946 28.329 7.12904C28.5985 7.39863 28.75 7.76426 28.75 8.14551V19.6455C28.75 20.439 29.394 21.083 30.1875 21.083H34.0266C34.4078 21.083 34.7735 21.2345 35.043 21.504C35.3126 21.7736 35.4641 22.1393 35.4641 22.5205V38.333H31.625V33.0622C31.625 32.6809 31.4735 32.3153 31.204 32.0457C30.9344 31.7761 30.5687 31.6247 30.1875 31.6247H15.8125C15.4312 31.6247 15.0656 31.7761 14.796 32.0457C14.5264 32.3153 14.375 32.6809 14.375 33.0622V38.333H10.5417V8.14551ZM28.75 34.4997V38.333H24.4375V34.4997H28.75ZM21.5625 34.4997V38.333H17.25V34.4997H21.5625Z"
                    fill="#37383D"
                  />
                </svg>
                수임 업체 등록하기
              </IconButton>
            </MultiButton>
          )}
        </>
      )}
      {!onBoardingClose && author !== 'employee' && (
        <div className={styles.onboarding_wrap}>
          <Flex justifyContent={'space-between'}>
            <img src={logo} alt="휴램 로고" height="36" />
            <IconButton
              className={styles.onboarding_close_button}
              onClick={() => onBoardingHandler()}
            >
              <DeleteIcon />
            </IconButton>
          </Flex>
          <div className={styles.onboarding_title_box}>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}>
              <h2 className={styles.onboarding_title_wrap}>
                <span>👋 휴램프로</span>
                <span>사용 방법을 도와드릴게요.</span>
              </h2>
              {isOnBoardingInit === false && (
                <OnboardingItem
                  type={'icon'}
                  show={!isOnBoardingInit}
                  onOpen={onOpenVideoModal}
                  style={{
                    paddingBottom: 8,
                  }}
                  {...onBoardingData}
                />
              )}
            </div>
            {isOnBoardingInit && (
              <OnboardingItem
                type={'bottom'}
                show={isOnBoardingInit}
                onClose={setPageOnboarding}
                onOpen={onOpenVideoModal}
                {...onBoardingData}
              />
            )}
          </div>
          <div className={styles.onboarding_ord_box}>
            <h3>아래 순서대로 정보 입력 후 수임 업체 등록을 진행해보세요.</h3>
            <ol>
              <li>
                <span className={styles.desc_no}>1</span>
                <div>
                  <div className={styles.ord_title_box}>
                    <h4>4대 보험 연동을 통해 수임 업체 등록하기</h4>
                    <p>
                      환경설정 혹은 수임업체 메뉴에서 4대 보험 연동을 통해 수임 업체를 가져올 수
                      있어요.
                    </p>
                  </div>
                  <Button href="/hulamCompanyList" type="line-purple" width={240}>
                    수임 업체 등록하기
                  </Button>
                </div>
              </li>
              <li>
                <span className={styles.desc_no}>2</span>
                <div>
                  <div className={styles.ord_title_box}>
                    <h4>직원 정보 등록하기</h4>
                    <p>직원 관리에서 직원 등록을 통해 직원을 등록할 수 있어요.</p>
                  </div>
                  <Button href="/hulamEmployee" type="line-purple" width={240}>
                    직원 관리
                  </Button>
                </div>
              </li>
              <li>
                <span className={styles.desc_no}>3</span>
                <div>
                  <div className={styles.ord_title_box}>
                    <h4>수임 업체별 담당 직원 설정하기</h4>
                    <p>좌측 수임 업체 메뉴에서 수임 업체별로 담당 직원을 설정할 수 있어요.</p>
                  </div>
                  <Button href="/hulamCompanyList" type="line-purple" width={240}>
                    수임 업체
                  </Button>
                </div>
              </li>
            </ol>
          </div>
        </div>
      )}
      {onboardingModal && (
        <OnBoardingVideoModal
          {...onBoardingData}
          isOpen={onboardingModal}
          onClosed={onCloseVideoModal}
        />
      )}
    </div>
  );
};
